<template>
    <div>
        <h4>Your saved documents</h4>

        <div class="documents" v-if="documents.length > 0">
            <ol>
                <li v-for="document in documents" :key="document.objectId">
                    <p>Document: {{document.document}} Language: {{document.language}} 
                        <el-button @click="$emit('loadDocument', document)" type="primary" size="mini">Load</el-button> 
                        <el-button @click="$emit('deleteDocument', document)" type="danger" size="mini">Delete</el-button> 
                    </p>
                </li>
            </ol>
        </div>
        <div v-else>
            You have not saved documents, you are using default.
        </div>
    </div>
</template>

<script type="text/babel">

export default {
    name: 'ListDocuments',
    data(){
        return {
            
        }
    },
    methods: {
      
    },
    props: {
        documents: {
            type: Array,
            default: []
        }
    },
};
</script>
